import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './daily-product-usage.reducer';

export const DailyProductUsage = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const dailyProductUsageList = useAppSelector(state => state.dailyProductUsage.entities);
  const loading = useAppSelector(state => state.dailyProductUsage.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="daily-product-usage-heading" data-cy="DailyProductUsageHeading">
        <Translate contentKey="crawlerBackendApp.dailyProductUsage.home.title">Daily Product Usages</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.dailyProductUsage.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/daily-product-usage/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.dailyProductUsage.home.createLabel">
              Create new Daily Product Usage
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {dailyProductUsageList && dailyProductUsageList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.dailyProductUsage.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="crawlerBackendApp.dailyProductUsage.price">Price</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('price')} />
                </th>
                <th className="hand" onClick={sort('from')}>
                  <Translate contentKey="crawlerBackendApp.dailyProductUsage.from">From</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('from')} />
                </th>
                <th className="hand" onClick={sort('util')}>
                  <Translate contentKey="crawlerBackendApp.dailyProductUsage.util">Util</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('util')} />
                </th>
                <th className="hand" onClick={sort('dailyUsage')}>
                  <Translate contentKey="crawlerBackendApp.dailyProductUsage.dailyUsage">Daily Usage</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('dailyUsage')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.dailyProductUsage.product">Product</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {dailyProductUsageList.map((dailyProductUsage, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/daily-product-usage/${dailyProductUsage.id}`} color="link" size="sm">
                      {dailyProductUsage.id}
                    </Button>
                  </td>
                  <td>{dailyProductUsage.price}</td>
                  <td>
                    {dailyProductUsage.from ? (
                      <TextFormat type="date" value={dailyProductUsage.from} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {dailyProductUsage.util ? (
                      <TextFormat type="date" value={dailyProductUsage.util} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{dailyProductUsage.dailyUsage}</td>
                  <td>
                    {dailyProductUsage.product ? (
                      <Link to={`/product/${dailyProductUsage.product.id}`}>{dailyProductUsage.product.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/daily-product-usage/${dailyProductUsage.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/daily-product-usage/${dailyProductUsage.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() => (window.location.href = `/daily-product-usage/${dailyProductUsage.id}/delete`)}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.dailyProductUsage.home.notFound">
                No Daily Product Usages found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default DailyProductUsage;
